module.exports = __webpack_public_path__ + "static/media/dark-motion-sequence.3c05c51.mp4";